<template>
  <div
    :class="[
      'nav-lists-container',
      {
        'nav-lists-container--3-col': hasTabs && hasCard,
        'nav-lists-container--4-col': (!hasTabs && hasCard) || (!hasCard && hasTabs),
        'nav-lists-container--just-lists': !hasTabs && !hasCard,
      },
    ]"
  >
    <nav-list
      v-for="list in lists"
      :key="list.columnHeader"
      :column-header="list.columnHeader"
      :uid="list.uid"
      :links="filterLinks(list.links)"
    />
  </div>
</template>

<script>
import NavList from '@/navigation/components/NavList';
import {mapState} from 'vuex';

export default {
  name: 'NavListsLayout',
  components: {NavList},
  props: {
    hasCard: {
      type: Boolean,
      default: false,
    },
    hasTabs: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState('navigation', ['activeTab', 'currentOverlay']),
    lists() {
      const lists = this.currentOverlay?.tabs.find((tab) => tab.uid === this.activeTab && tab.visible == true)?.lists;
      return lists ? lists.filter((list) => list.visible && this.filterLinks(list.links).length) : null;
    },
  },

  methods: {
    filterLinks(links) {
      // This conditional logic matches what's in navNode.tag
      return links.filter((link) => link.visible && this.linkNotRestricted(link) && this.linkHasUrl(link));
    },
    linkNotRestricted(link) {
      return this.currentOverlay.hideLinksWithoutProducts ? link.hasVisibleProducts : true;
    },
    linkHasUrl(link) {
      return link.url && link.url.charAt(0) !== '#';
    },
  },
};
</script>

<style lang="scss" scoped>
.nav-lists-container {
  display: grid;
  gap: 2rem;
  grid-auto-rows: min-content;

  &.nav-lists-container--3-col {
    @include breakpoint(large) {
      grid-template-columns: repeat(3, 1fr);
    }
  }

  &.nav-lists-container--4-col {
    @include breakpoint(large) {
      grid-template-columns: repeat(4, 1fr);
    }
  }

  &.nav-lists-container--just-lists {
    @include breakpoint(large) {
      grid-template-columns: repeat(5, 1fr);
    }
    @include breakpoint(xlarge) {
      grid-template-columns: repeat(6, 1fr);
    }
  }
}
</style>
